import InputSelect from "../InputSelect";
import { useState, useContext, useEffect } from "react";
import GlobalContext from "../../context/GlobalContext";
import { fetchSelectPayrollTemplates } from "../../api/PayrollApi";
import { components as ReactSelectComponents } from "react-select";

import { tr } from "../../i18n";
const SelectPayrollTemplate = (props) => {
  const { user } = useContext(GlobalContext);
  const [options, setOptions] = useState([]);
  const [defaultOption, setDefaultOption] = useState(null);

  const customComponents = {
    // Icon template saat sudah dipilih
    SingleValue: (props) => (
      <ReactSelectComponents.SingleValue {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <i
            className="fas fa-file-invoice"
            style={{ marginRight: 8, color: "#6c757d" }}
          ></i>
          {props.data.label}
        </div>
      </ReactSelectComponents.SingleValue>
    ),
    // Icon template di setiap opsi
    Option: ({ data, innerRef, innerProps }) => (
      <div
        className="react-custom-single-value"
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", padding: "10px" }}
      >
        <i
          className="fas fa-file-invoice"
          style={{ marginRight: 8, color: "#6c757d" }}
        ></i>
        {data.label}
      </div>
    ),
  };

  const data = {
    name: props.name,
    className: props.className,
    rules: props.rules,
    components: customComponents,
    placeholder: props.placeholder || tr("payroll:choose_template"),
    options: options,
    key: null,
    label: props.label,
    defaultValue: defaultOption,
    disabled: props.disabled,
    isMulti: props.isMulti,
  };

  const fetchData = async (keyword = "", defaultValue = "") => {
    try {
      const dataList = await fetchSelectPayrollTemplates(
        user.workspace.company_id,
        keyword,
        defaultValue
      );

      if (defaultValue) {
        return dataList;
      } else {
        return dataList.data.map((data) => ({
          label: String(data.text),
          value: String(data.id),
        }));
      }
    } catch (error) {
      console.error("Error fetching payroll templates", error);
      return [];
    }
  };

  useEffect(() => {
    // Hanya load jika defaultOption masih null (belum pernah di-set)
    if (defaultOption !== null) return;

    const loadInitialData = async () => {
      // Jika props.defaultValue adalah object dengan value dan label (sudah bentuk option)
      if (
        props.defaultValue &&
        typeof props.defaultValue === "object" &&
        "value" in props.defaultValue &&
        "label" in props.defaultValue
      ) {
        setDefaultOption(props.defaultValue);
      }
      // Jika props.defaultValue adalah array of objects (multi select)
      else if (
        Array.isArray(props.defaultValue) &&
        props.defaultValue.length > 0
      ) {
        setDefaultOption(props.defaultValue);
      }
      // Jika props.defaultValue adalah ID (string atau number), fetch dari API
      else if (props.defaultValue) {
        const defaultData = await fetchData("", props.defaultValue);
        if (defaultData?.data?.[0]) {
          setDefaultOption(defaultData.data[0]);
        }
      }
    };

    loadInitialData();
  }, [props.defaultValue]); // Tetap ada dependency tapi ada guard di atas

  async function handleData(search = "") {
    const result = await fetchData(search);
    return result;
  }

  return (
    <div
      className="select-container"
      style={{ textAlign: "left", width: "100%" }}
    >
      <InputSelect
        data={data}
        handleChange={() => {}}
        handleOnLoadData={handleData}
        components={customComponents}
      />
    </div>
  );
};

export default SelectPayrollTemplate;
